import { createSelector } from 'reselect';

import {
  // Frame
  hasUserSelector,
  // Features
  featuresIsPremiumSelector,
  featuresIsProJobsSelector,
  featuresIsProBusinessSelector,
  // Navigation
  navigationHomeSelector,
  navigationMessagesSelector,
  navigationContactsSelector,
  navigationPremiumSelector,
  navigationPremiumUpsellSelector,
  navigationProJobsSelector,
  navigationProBusinessSelector,
  navigationJobsSelector,
  navigationEventsSelector,
  navigationContentSelector,
  navigationGroupsSelector,
  navigationCompaniesSelector,
  navigationBusinessSelector,
} from '@xingternal/platform-layout-selectors';

const itemsInputSelectors = [
  hasUserSelector,
  featuresIsPremiumSelector,
  featuresIsProJobsSelector,
  featuresIsProBusinessSelector,
  navigationHomeSelector,
  navigationMessagesSelector,
  navigationContactsSelector,
  navigationPremiumSelector,
  navigationPremiumUpsellSelector,
  navigationProJobsSelector,
  navigationProBusinessSelector,
  navigationJobsSelector,
  navigationEventsSelector,
  navigationContentSelector,
  navigationGroupsSelector,
  navigationCompaniesSelector,
  navigationBusinessSelector,
];

const itemsTransform = (
  hasUser,
  isPremium,
  isProJobs,
  isProBusiness,
  home,
  messages,
  contacts,
  premium,
  premiumUpsell,
  proJobs,
  proBusiness,
  jobs,
  events,
  content,
  groups,
  companies,
  business,
  services
) => {
  return [
    home,
    contacts,
    messages,
    ...(hasUser
      ? [
          isPremium ? premium : premiumUpsell,
          isProJobs && proJobs,
          isProBusiness && proBusiness,
          jobs,
          events,
          content,
          groups,
          companies,
          business,
          services,
        ]
      : []),
  ].filter(Boolean);
};

const navigationItemsSelector = createSelector(
  ...itemsInputSelectors,
  itemsTransform
);
export { navigationItemsSelector };
